export const legacyResources = {
  zh: {
    'dynamic.appCount': '{{count}} 个应用',
    'dynamic.appCenterSummary':
      '{{total}} 个应用 · 已上线 {{live}} · 规划中 {{planned}} · 集成 {{integrations}}',
    'dynamic.appCenterNoMatch': '没有匹配 "{{keyword}}" 的应用',
    'dynamic.itemCount': '{{count}} 个',
    'dynamic.agentToolSummary':
      '{{count}} 个 AgentTool · 自动注册自后端 @AgentTool 装饰器 · Phase 2 直供 LangGraph LLM 调用',
    'dynamic.agentToolNoMatch': '没有匹配 "{{keyword}}" 的工具',
    'dynamic.agentToolEmpty': '暂无注册的 AgentTool',
    'dynamic.toolCount': '{{count}} 个工具',
    'dynamic.namespaceCount': '{{count}} 个命名空间',
    'dynamic.linkedRoles': '已关联 {{count}} 个角色',
    'dynamic.fspFields': '字段权限 ({{count}})',
    'dynamic.fspRoles': '关联角色 ({{count}})',
    'dynamic.settingsSummary': '{{count}} 项 · 系统字典与基础配置',
    'dynamic.rolePrivilegeSaved': '已保存 — 新增 {{added}}, 更新 {{updated}}, 移除 {{removed}}',
    'dynamic.savePrivilegeChanges': '保存权限 ({{count}} 改动)',
    'dynamic.assignmentSummary': '共 {{total}} 条 · 已授予 {{granted}} 条',
    'dynamic.paginationRange': '第 {{start}}-{{end}} 条 / 共 {{total}} 条',
    'dynamic.updateSapDocTitle': '更新 SAP 销售凭证 (VBELN: {{vbeln}})',
    'dynamic.sapQueued': '已入队 ({{mode}}) jobId={{jobId}}...',
    'dynamic.sapModeUpdate': '更新',
    'dynamic.sapModeCreate': '创建',
    'dynamic.updateSapButton': '更新 SAP ({{vbeln}})',
    'components.admincrudpage.01237d41': '已创建',
    'components.admincrudpage.0f11a330': '取消',
    'components.admincrudpage.2f1e2ff9': '已删除',
    'components.admincrudpage.47e49f2d': '新建',
    'components.admincrudpage.49979665': '确认删除？',
    'components.admincrudpage.539443b5': '新建',
    'components.admincrudpage.6e6a9139': '保存',
    'components.admincrudpage.86e97d5f': '编辑',
    'components.admincrudpage.bd1a2c41': '已更新',
    'components.attachmentlist.6a4a289c': '上传时弹出"文档归属"选择；支持多文件批量；单文件 ≤ 10MB',
    'components.attachmentlist.775f084e': '选择文档归属',
    'components.attachmentlist.88186e58': '附件',
    'components.attachmentlist.9716a894': ' — 点击或拖拽上传',
    'components.attachmentlist.bb9d8c69': '暂无附件',
    'components.attachmentlist.d652c433': '共 ',
    'components.attachmentlist.e90a36ac':
      ' 个文件待上传，请选择归属类别（所有文件归到同一类别，上传后可在列表里查看/删除）：',
    'components.exportbutton.2788067f': '已下载',
    'components.exportbutton.2e0253bf': '导出 Excel',
    'components.multipresalessubgrid.221a644d': '销售技术支持工程师',
    'components.multipresalessubgrid.3cac4655': '开始',
    'components.multipresalessubgrid.76dc7c62': '其他',
    'components.multipresalessubgrid.7a101ff9': '结束',
    'components.multipresalessubgrid.9be58af0': '角色',
    'components.multipresalessubgrid.affc5965': '产品专家',
    'components.multipresalessubgrid.b7d8e7cd': '解决方案架构师',
    'components.multipresalessubgrid.c3d9980c': '顾问',
    'components.multipresalessubgrid.c6771690': '支持时段',
    'components.multipresalessubgrid.e43a18f0': '用户',
    'components.multipresalessubgrid.ec82a182': '权限',
    'components.notificationbell.b775cfe8': '实时通知',
    'components.pricelookup.027e10b4': '所有匹配',
    'components.pricelookup.126c0b09': '数量',
    'components.pricelookup.1353db1c': '折扣价',
    'components.pricelookup.1ff4854f': '目录价',
    'components.pricelookup.5207b105': '国内简表',
    'components.pricelookup.5daf1dd5': '子分类',
    'components.pricelookup.62f5aeed': '查询价格',
    'components.pricelookup.6467edf2': '毛利率',
    'components.pricelookup.6815ef6c': '授权价',
    'components.pricelookup.849c97d5': '国家',
    'components.pricelookup.ab2fd02e': '型号',
    'components.pricelookup.d86f1b03': '价格查询参数',
    'components.pricelookup.e9a9fa69': '海外简表',
    'components.pricelookup.ef792a83': '基础价格库',
    'components.quickcreate.10c4f4f0': '客户名称',
    'components.quickcreate.182027db': '新建',
    'components.quickcreate.2092add1': '潜在客户',
    'components.quickcreate.2bfe7b0a': '公司名称',
    'components.quickcreate.49de1b83': '商机主题',
    'components.quickcreate.606723b2': '主要电话',
    'components.quickcreate.634f6c1b': '姓',
    'components.quickcreate.68983c0b': '职务',
    'components.quickcreate.8a1ba983': '客户编号',
    'components.quickcreate.8d98732d': '名',
    'components.quickcreate.9b7dcd18': '联系人',
    'components.quickcreate.ae9ef22c': '所属客户',
    'components.quickcreate.b85b9e64': '手机',
    'components.quickcreate.bed46160': '邮箱',
    'components.quickcreate.e1c34658': '网站',
    'components.quickcreate.ee650671': '主题',
    'components.salesforecastsubgrid.1bd9aa34': '备注',
    'components.salesforecastsubgrid.214d40ee': '数量',
    'components.salesforecastsubgrid.2c31b92d': '频段',
    'components.salesforecastsubgrid.2cbff4f1': '单价',
    'components.salesforecastsubgrid.6d48ebd6': '产品大类',
    'components.salesforecastsubgrid.8151df00': '子分类',
    'components.salesforecastsubgrid.b38dbb7d': '合计',
    'layout.applayout.48d19dad': '欢迎，',
    'layout.applayout.48dc23eb': '使用默认菜单 (sitemap 未配置)',
    'layout.applayout.sitemapLoadFailed': '菜单加载失败，请刷新页面重试',
    'layout.applayout.sitemapLoading': '加载菜单中...',
    'layout.applayout.d3fc5db4': '退出',
    'layout.appswitcher.f8ab9259': '请选择应用',
    'pages.account.accountcreatemodal.28ea6385': '暂未选择文件',
    'pages.account.accountcreatemodal.d0c3718b': '支持 PDF / 图片',
    'pages.account.accountdetailpage.03226901': '备用地址',
    'pages.account.accountdetailpage.0bc70d10': '账单',
    'pages.account.accountdetailpage.0ed3074f': '提交',
    'pages.account.accountdetailpage.39691604': '运输',
    'pages.account.accountdetailpage.5cd8d2bb': '联络偏好',
    'pages.account.accountdetailpage.86e1e37a': '客户信息',
    'pages.account.accountdetailpage.8a3f29e9': '系统信息',
    'pages.account.accountdetailpage.905018df': '附件',
    'pages.account.accountdetailpage.92406ebe': '概要',
    'pages.account.accountdetailpage.ab4b4b81': '公司信息',
    'pages.account.accountdetailpage.b8af1d85': 'SAP 客户扩展',
    'pages.account.accountdetailpage.c9dd7e89': '地址',
    'pages.account.accountdetailpage.dc168816': '营销',
    'pages.account.accountdetailpage.e1beb8f3': 'SAP 同步',
    'pages.account.accountdetailpage.eed2eba9': '收发货 / 财务',
    'pages.account.accountdetailpage.f133710d': '说明',
    'pages.account.accountdetailpage.f2911700': 'SAP',
    'pages.account.accountdetailpage.f69608c0': '取消提交',
    'pages.admin.adminuserspage.07f977b4': '角色',
    'pages.admin.adminuserspage.0b131f60': '取消',
    'pages.admin.adminuserspage.0cb05934': '启用账户',
    'pages.admin.adminuserspage.1697a1bc': '启用',
    'pages.admin.adminuserspage.17cfbbd0': '确认',
    'pages.admin.adminuserspage.2f0008a4': '姓名',
    'pages.admin.adminuserspage.42e5b836': '用户管理',
    'pages.admin.adminuserspage.750d8a77': '总用户',
    'pages.admin.adminuserspage.85c5cb55': '禁用',
    'pages.admin.adminuserspage.a9d032b9': '禁用账户',
    'pages.admin.adminuserspage.ada9cdbe': '可分配角色',
    'pages.admin.adminuserspage.b348315f': '邮箱',
    'pages.admin.adminuserspage.d0cf70a8': '业务部门',
    'pages.admin.adminuserspage.e6ddfbbd': '当前角色',
    'pages.admin.appcenterpage.15013820': '搜索应用 / 标签',
    'pages.admin.appcenterpage.29849f31': '预计',
    'pages.admin.appcenterpage.9eb59229':
      '联系超级管理员 — 通过 manifest JSON + sitemap 配置即可挂载子应用 (插件机制详见 Phase 2 路线图)',
    'pages.admin.appcenterpage.b29cfd52': '应用中心',
    'pages.admin.appcenterpage.c1f369f8': '如何接入新应用？',
    'pages.admin.bulkassignrolesmodal.3ed28929': '角色',
    'pages.admin.bulkassignrolesmodal.755dc6ac': '移除角色',
    'pages.admin.bulkassignrolesmodal.87be5c22': '操作模式',
    'pages.admin.bulkassignrolesmodal.de973ef2': '增加角色',
    'pages.admin.bulkassignrolesmodal.f7d3cde3': '替换角色',
    'pages.admin.butreepage.0efeca48': '部门名称',
    'pages.admin.butreepage.301d2ad8': '事业部',
    'pages.admin.butreepage.7b4601b8': '联系邮箱',
    'pages.admin.butreepage.8e667fe5': '成本中心',
    'pages.admin.butreepage.f8d0ec76': '企业组织架构',
    'pages.admin.createrolemodal.0dd8707b': '系统 — IT/系统管理类',
    'pages.admin.createrolemodal.97edd3e1': '审核 — 审批/审核人员',
    'pages.admin.createrolemodal.9e48a5da': '描述',
    'pages.admin.createrolemodal.c0277b71': '管理 — 经理/总监/VP',
    'pages.admin.createrolemodal.d27efee7': '业务 — 销售/运维等业务人员',
    'pages.admin.createrolemodal.d4eb4d2b': '角色类型',
    'pages.admin.createrolemodal.d5761590': '角色名',
    'pages.admin.createrolemodal.dc4a45ea': '显示名称',
    'pages.admin.createusermodal.90984ef9': '姓名',
    'pages.admin.createusermodal.95ad87df': '邮箱',
    'pages.admin.createusermodal.987a2667': '初始角色',
    'pages.admin.createusermodal.b38defc1': '可多选',
    'pages.admin.createusermodal.b8a81f06': '登录账号',
    'pages.admin.createusermodal.e2395cb8': '初始密码',
    'pages.admin.createusermodal.e3e67201': '所属部门',
    'pages.admin.fspdetaildrawer.00c92668': '实体',
    'pages.admin.fspdetaildrawer.051533f3': '选择角色',
    'pages.admin.fspdetaildrawer.07bd9fba': '描述',
    'pages.admin.fspdetaildrawer.0d887427': '删除',
    'pages.admin.fspdetaildrawer.1fdcd7ef':
      '勾选哪些角色应应用此 FSP（多选；保存后立即生效，受 5 分钟缓存）',
    'pages.admin.fspdetaildrawer.2d73563c': '可建',
    'pages.admin.fspdetaildrawer.2e19c086': '角色',
    'pages.admin.fspdetaildrawer.3bd1d0fa': '实体名 (entityname)',
    'pages.admin.fspdetaildrawer.49c0259b': '可读',
    'pages.admin.fspdetaildrawer.4cb95ee8': '可改',
    'pages.admin.fspdetaildrawer.5f5b367e': '确认删除？',
    'pages.admin.fspdetaildrawer.62d7cd7e': '请填写实体和字段名',
    'pages.admin.fspdetaildrawer.6e89346f': '取消',
    'pages.admin.fspdetaildrawer.73befbb7': '通用',
    'pages.admin.fspdetaildrawer.7839c51a': '名称',
    'pages.admin.fspdetaildrawer.7b8407d6': '字段',
    'pages.admin.fspdetaildrawer.7c5f525b': '保存失败',
    'pages.admin.fspdetaildrawer.9156c851': '保存',
    'pages.admin.fspdetaildrawer.99072325': '保存关联',
    'pages.admin.fspdetaildrawer.9e5719cf': '已添加字段权限',
    'pages.admin.fspdetaildrawer.a71b02df': '字段',
    'pages.admin.fspdetaildrawer.c1532d8c': '删除失败',
    'pages.admin.fspdetaildrawer.c70468d1': '已删除字段权限',
    'pages.admin.fspdetaildrawer.ca663086': '已保存',
    'pages.admin.fspdetaildrawer.cbead127': '添加失败',
    'pages.admin.fspdetaildrawer.d39e1073': '添加',
    'pages.admin.fspdetaildrawer.d50425e0': '字段名 (attributelogicalname)',
    'pages.admin.fspdetaildrawer.e6b79944': '内置',
    'pages.admin.fspdetaildrawer.fd70a5f0': 'FSP 详情',
    'pages.admin.fsplistpage.11825369': '已创建 FSP',
    'pages.admin.fsplistpage.16c0f5ac': '创建',
    'pages.admin.fsplistpage.27e68f15': '创建失败',
    'pages.admin.fsplistpage.3fbd7515': '内置',
    'pages.admin.fsplistpage.444baaba': '关联角色',
    'pages.admin.fsplistpage.527553a2': '暂无 FSP 配置',
    'pages.admin.fsplistpage.66528e9c': '点击"创建"新增',
    'pages.admin.fsplistpage.6734022b': '搜索名称',
    'pages.admin.fsplistpage.6a209a04': '字段数',
    'pages.admin.fsplistpage.756e9999': '描述',
    'pages.admin.fsplistpage.80d311ec': '请填写 FSP 名称',
    'pages.admin.fsplistpage.974a49eb': '名称 / Name',
    'pages.admin.fsplistpage.b8f956b4': '查询',
    'pages.admin.fsplistpage.b9ab4d36': '刷新',
    'pages.admin.fsplistpage.cc8ff5c5': '新 FSP 名称（点击右侧创建）',
    'pages.admin.fsplistpage.d545b5f9':
      '配置每个角色可见 / 可改的字段（如中信保批复金额仅审批人可见）',
    'pages.admin.fsplistpage.fc7eff36': '字段安全配置 / FSP',
    'pages.admin.notifyhistorypage.15148342': '邮箱配置',
    'pages.admin.notifyhistorypage.5c4f7674': '测试发送',
    'pages.admin.notifyhistorypage.c3a6c0a7': '时间',
    'pages.admin.notifyhistorypage.e86ec937': '测试邮件已发送',
    'pages.admin.notifyhistorypage.fdef161a': '发送',
    'pages.admin.roledetaildrawer.0141adb4': '内置角色权限只读',
    'pages.admin.roledetaildrawer.24046374': '业务',
    'pages.admin.roledetaildrawer.3de149c9': '权限名称',
    'pages.admin.roledetaildrawer.3ececf03': '保存',
    'pages.admin.roledetaildrawer.48fedf10': '加载权限失败',
    'pages.admin.roledetaildrawer.5680a4c4': 'App 访问',
    'pages.admin.roledetaildrawer.5aa3421a': '保存菜单权限',
    'pages.admin.roledetaildrawer.681da459': '权限',
    'pages.admin.roledetaildrawer.6bbbf35a': '保存 App 访问',
    'pages.admin.roledetaildrawer.6eb40301': '搜索 privilege 名称',
    'pages.admin.roledetaildrawer.6f5d885a': '已改',
    'pages.admin.roledetaildrawer.77506a2a': '管理',
    'pages.admin.roledetaildrawer.8842a540': '深度',
    'pages.admin.roledetaildrawer.depthBasic': '基础',
    'pages.admin.roledetaildrawer.depthDeep': '深度',
    'pages.admin.roledetaildrawer.depthGlobal': '全局',
    'pages.admin.roledetaildrawer.depthLocal': '本地',
    'pages.admin.roledetaildrawer.a591b62a': '未找到匹配权限',
    'pages.admin.roledetaildrawer.aa38675d': '保存失败',
    'pages.admin.roledetaildrawer.b57db90b': '改动',
    'pages.admin.roledetaildrawer.bfc11382': '系统',
    'pages.admin.roledetaildrawer.dd13acfc': '审核',
    'pages.admin.roledetaildrawer.e05809ab': '显示名称',
    'pages.admin.roledetaildrawer.ee336179': '未授予',
    'pages.admin.settingshubpage.3a6f65d5': '参数配置',
    'pages.admin.settingspages.04983a9a': '收件人',
    'pages.admin.settingspages.0bcff807': '部门名称',
    'pages.admin.settingspages.0cce9698': '区域',
    'pages.admin.settingspages.0e895da8': '配置名称',
    'pages.admin.settingspages.1353ff2f': '来源名称',
    'pages.admin.settingspages.18d48309': '映射名称',
    'pages.admin.settingspages.201a91e2': '型号',
    'pages.admin.settingspages.21cc6701': '主管',
    'pages.admin.settingspages.2b2d384a': '来源代码',
    'pages.admin.settingspages.2d72ead4': '名称',
    'pages.admin.settingspages.321d6a50': '签约公司',
    'pages.admin.settingspages.34942e7e': 'ISO 代码',
    'pages.admin.settingspages.3ad08a91': '国家代码',
    'pages.admin.settingspages.44c9ad52': '大洲',
    'pages.admin.settingspages.49ae47b7': '签约公司代码',
    'pages.admin.settingspages.4b03b3b8': '国家',
    'pages.admin.settingspages.544ae29d': '型号系列',
    'pages.admin.settingspages.62b4389b': '共享名称',
    'pages.admin.settingspages.69038513': '符号',
    'pages.admin.settingspages.77cfc255': '结束时间',
    'pages.admin.settingspages.78445cc8': '币种名称',
    'pages.admin.settingspages.899a82e1': '红线价',
    'pages.admin.settingspages.8d66b9ba': '开始时间',
    'pages.admin.settingspages.93f0200d': '汇率',
    'pages.admin.settingspages.946a7b63': '描述',
    'pages.admin.settingspages.class_parent_group': '所属产品组',
    'pages.admin.settingspages.class_subclass_count': '关联小类数',
    'pages.admin.settingspages.group_class_count': '关联大类数',
    'pages.admin.settingspages.subclass_parent_class': '所属产品大类',
    'pages.admin.settingspages.subclass_parent_group': '所属产品族',
    'pages.admin.settingspages.filter_by_group': '按产品族筛选',
    'pages.admin.settingspages.filter_by_class': '按产品大类筛选',
    'pages.admin.settingspages.only_unlinked': '仅看未关联大类',
    'pages.admin.settingspages.9925f04f': '角色',
    'pages.admin.settingspages.9955cccc': '语言代码',
    'pages.admin.settingspages.99b212b9': '英文名',
    'pages.admin.settingspages.9bd3aa9f': '电话区号',
    'pages.admin.settingspages.9c240348': '地址',
    'pages.admin.settingspages.a1021b0b': '值 (Value)',
    'pages.admin.settingspages.a6be3b91': '办事处名称',
    'pages.admin.settingspages.aed67b52': '键 (Key)',
    'pages.admin.settingspages.c161d2bb': '事业部',
    'pages.admin.settingspages.c2a38303': '语言名称',
    'pages.admin.settingspages.c4f06c14': '网站',
    'pages.admin.settingspages.dea8a339': '代码',
    'pages.admin.settingspages.e791860f': '类别',
    'pages.admin.settingspages.ebd5d61b': '业务功能',
    'pages.admin.settingspages.ee995b35': '值',
    'pages.admin.settingspages.efb21ff3': '物料编号',
    'pages.admin.settingspages.f1743e59': '邮箱',
    'pages.admin.settingspages.f76a23ee': '键',
    'pages.admin.settingspages.fcfb02ff': '中文名',
    'pages.contact.contactcreatemodal.403bcd67': '电话',
    'pages.contact.contactcreatemodal.4905f98e': '全名',
    'pages.contact.contactcreatemodal.4b316048': '暂未选择文件',
    'pages.contact.contactcreatemodal.4c9cab4d': '地址',
    'pages.contact.contactcreatemodal.6ef74b5f': '支持 PDF / 图片',
    'pages.contact.contactcreatemodal.c6148052': '任意',
    'pages.contact.contactcreatemodal.c7945116': '邮寄',
    'pages.contact.contactcreatemodal.c884d020': '个人资料',
    'pages.contact.contactcreatemodal.e3b99d6b': '备注',
    'pages.contact.contactcreatemodal.e8a12d61': '联络偏好',
    'pages.contact.contactcreatemodal.ea38fb39': '邮件',
    'pages.contact.contactcreatemodal.f8c958a2': '更多联系方式',
    'pages.contact.contactcreatemodal.fd739909': '传真',
    'pages.contact.contactdetailpage.68a6467c': '概要',
    'pages.contact.contactdetailpage.6d28c558': '附件',
    'pages.dashboard.salesdashboardpage.02ea5c1e': '年度赢单',
    'pages.dashboard.salesdashboardpage.15e3ba17': 'BPF 阶段 SLA',
    'pages.dashboard.salesdashboardpage.23224099': 'TOP 5 商机',
    'pages.dashboard.salesdashboardpage.2b1a2f31': '本月赢单',
    'pages.dashboard.salesdashboardpage.95ca2715': '加权预测',
    'pages.dashboard.salesdashboardpage.a97e08cb': 'BPF 漏斗',
    'pages.dashboard.salesdashboardpage.dd5e4c6f': '进行中商机',
    'pages.delivery.deliverydetailpage.08a8a9e7': '执行',
    'pages.delivery.deliverydetailpage.1775a646': '已验收',
    'pages.delivery.deliverydetailpage.2143bef1': '未验收',
    'pages.delivery.deliverydetailpage.25f8f103': '拒收',
    'pages.delivery.deliverydetailpage.3f13a842': '验收中',
    'pages.delivery.deliverydetailpage.53b95577': '验收',
    'pages.delivery.deliverydetailpage.6bff7bff': '团队',
    'pages.delivery.deliverydetailpage.79ed48d3': '项目信息',
    'pages.delivery.deliverydetailpage.7e866511': '关闭',
    'pages.delivery.deliverydetailpage.8bb34e1a': '启动',
    'pages.delivery.deliverydetailpage.abc0217b': '系统信息',
    'pages.delivery.deliverydetailpage.c1705459': '项目进度',
    'pages.delivery.deliverydetailpage.dba5c7e6': '概要',
    'pages.entity.entitydetailpage.1390ef07': '放弃',
    'pages.entity.entitydetailpage.1c686a46': '取消',
    'pages.entity.entitydetailpage.3987c4b9': '本次未保存的改动将丢失',
    'pages.entity.entitydetailpage.5109db70': '概要',
    'pages.entity.entitydetailpage.5482b4c7': '基本信息',
    'pages.entity.entitydetailpage.5ab29c65': '只读',
    'pages.entity.entitydetailpage.61623b72': '继续编辑',
    'pages.entity.entitydetailpage.8d70e6cd': '刷新',
    'pages.entity.entitydetailpage.93680c16': '编辑',
    'pages.entity.entitydetailpage.b6f83ec8': '放弃修改？',
    'pages.entity.entitydetailpage.e10cf4cb': '保存',
    'pages.inbox.inboxpage.3a1bb433': '审批待办',
    'pages.inbox.inboxpage.3be669e2': '批准任务',
    'pages.inbox.inboxpage.5798fb3c': '批准',
    'pages.inbox.inboxpage.6a194bef': '审批意见（可选）',
    'pages.inbox.inboxpage.7339d6ed': '待审',
    'pages.inbox.inboxpage.74a547c5': '拒绝',
    'pages.inbox.inboxpage.7d05dbd0': '如：金额合理，可以批准。',
    'pages.inbox.inboxpage.a01f27cb': '批量拒绝',
    'pages.inbox.inboxpage.c03b1d13': '批量批准',
    'pages.inbox.inboxpage.c8a9119c': '如：金额超出权限，请重新提交。',
    'pages.inbox.inboxpage.cac4af0c': '已拒绝',
    'pages.inbox.inboxpage.cfc7c594': '拒绝任务',
    'pages.inbox.inboxpage.dfca8e8f': '已批准',
    'pages.inbox.inboxpage.fc2a7583': '已取消',
    'pages.lead.leadcreatemodal.490aca35': '暂未选择文件',
    'pages.lead.leadcreatemodal.79814209': '全名',
    'pages.lead.leadcreatemodal.aeae3eeb': '支持 PDF / 图片',
    'pages.lead.leaddetailpage.1eed6a89': '授予资格',
    'pages.lead.leaddetailpage.2c73c03c': '确认转化',
    'pages.lead.leaddetailpage.45ccf6be': '授予资格',
    'pages.lead.leaddetailpage.c02bc9c4': '已识别',
    'pages.lead.leaddetailpage.c11da8be': '商机',
    'pages.lead.leaddetailpage.c7e1861e': '客户',
    'pages.lead.leaddetailpage.dcc960d3': '潜在',
    'pages.lead.leaddetailpage.e155cda1': '附件',
    'pages.lead.leaddetailpage.f27d951b': '联系人',
    'pages.lead.leaddetailpage.f64f2248': '已取消',
    'pages.loginpage.56dfbedb': '登录',
    'pages.loginpage.6224a9d1': '开发环境默认账号: liuyayun@baicells.com / Crest@2026',
    'pages.loginpage.845973d5': '登录失败',
    'pages.loginpage.9336fb42': '密码',
    'pages.loginpage.a14d3cc1': '用户名 / 邮箱',
    'pages.loginpage.agentPlatform': 'AI Agent 企业全景运营台',
    'pages.loginpage.crmFooter': 'Baicells CRM Sales Center',
    'pages.loginpage.crmSalesCenter': 'CRM 销售中心',
    'pages.loginpage.erpFinanceCenter': 'ERP 财务中心',
    'pages.loginpage.erpFooter': 'Baicells ERP Finance Center',
    'pages.loginpage.dingtalkFailed': '钉钉登录失败，请重新尝试',
    'pages.loginpage.dingtalkLogin': '钉钉一键登录',
    'pages.loginpage.dingtalkPending': '正在完成钉钉登录...',
    'pages.loginpage.enterpriseIntel': 'Baicells Enterprise Intelligence',
    'pages.admin.butreepage.dingtalkSync': '同步钉钉组织',
    'pages.admin.butreepage.dingtalkSyncDone':
      '钉钉组织同步完成：部门新增 {{deptCreated}}、更新 {{deptUpdated}}；用户新增 {{userCreated}}、更新 {{userUpdated}}',
    'pages.admin.butreepage.dingtalkSyncFailed': '钉钉组织同步失败',
    'pages.admin.butreepage.scheduleEvery6h': '每 6 小时',
    'pages.admin.butreepage.scheduleEvery12h': '每 12 小时',
    'pages.admin.butreepage.scheduleEvery24h': '每天',
    'pages.admin.butreepage.scheduleEvery168h': '每周',
    'pages.admin.butreepage.notScheduled': '未设置',
    'pages.admin.butreepage.scheduleSaved': '同步计划已保存',
    'pages.admin.butreepage.syncWarningTitle': '同步会更新组织、用户和账号状态',
    'pages.admin.butreepage.syncWarningDesc':
      '立即同步会从钉钉重新拉取部门和用户，并按钉钉数据更新 CREST 企业组织与用户启停状态。',
    'pages.admin.butreepage.runNow': '立即同步',
    'pages.admin.butreepage.confirmSyncTitle': '确认立即同步钉钉组织？',
    'pages.admin.butreepage.confirmSyncDesc': '同步过程通常需要几十秒，期间请避免重复点击。',
    'pages.admin.butreepage.scheduleTitle': '定期同步',
    'pages.admin.butreepage.enableSchedule': '启用定期同步',
    'pages.admin.butreepage.saveSchedule': '保存计划',
    'pages.admin.butreepage.nextRun': '下次执行',
    'pages.admin.butreepage.lastRun': '上次执行',
    'pages.admin.butreepage.lastResult': '上次结果',
    'pages.admin.butreepage.showUsers': '显示人员',
    'pages.admin.butreepage.disabledUsers': '停用 {{count}}',
    'pages.admin.butreepage.dingtalkBound': '钉钉',
    'pages.admin.butreepage.syncSettingsTab': '同步设置',
    'pages.admin.butreepage.syncHistoryTab': '同步历史',
    'pages.admin.butreepage.noSyncHistory': '暂无同步历史',
    'pages.admin.butreepage.syncStatusSuccess': '成功',
    'pages.admin.butreepage.syncStatusFailed': '失败',
    'pages.admin.butreepage.syncStatusRunning': '进行中',
    'pages.admin.butreepage.triggerScheduled': '系统定时任务',
    'pages.admin.butreepage.triggerManual': '手动触发',
    'pages.admin.butreepage.showDiffs': '查看变化',
    'pages.admin.butreepage.hideDiffs': '收起变化',
    'pages.admin.butreepage.noActualChanges': '未发现实际变化',
    'pages.admin.butreepage.changeSummaryLine':
      '发现 {{total}} 项变化：用户 {{users}}、部门 {{departments}}',
    'pages.admin.butreepage.entityDepartment': '部门',
    'pages.admin.butreepage.entityUser': '用户',
    'pages.admin.butreepage.changeCreated': '新增',
    'pages.admin.butreepage.changeUpdated': '更新',
    'pages.admin.butreepage.changeDisabled': '禁用',
    'pages.admin.butreepage.changeRestored': '恢复',
    'pages.admin.butreepage.fieldFullName': '姓名',
    'pages.admin.butreepage.fieldEmail': '邮箱',
    'pages.admin.butreepage.fieldAccount': '登录账号',
    'pages.admin.butreepage.fieldBusinessUnit': '所属企业组织',
    'pages.admin.butreepage.fieldStatus': '状态',
    'pages.admin.butreepage.fieldSyncState': '钉钉状态',
    'pages.admin.butreepage.fieldDepartmentName': '部门名称',
    'pages.admin.butreepage.fieldParentDepartment': '上级部门',
    'pages.admin.butreepage.fieldSortOrder': '排序',
    'pages.admin.butreepage.emptyValue': '未设置',
    'pages.admin.butreepage.statusActive': '启用',
    'pages.admin.butreepage.statusDisabled': '禁用',
    'pages.admin.butreepage.statusDeparted': '已离职',
    'pages.admin.butreepage.onlyMetadataChanged': '仅同步元数据发生变化',
    'pages.loginpage.or': '或',
    'pages.operations.operationsdashboardpage.14bc003d':
      '1) 确认数据源 API / 表; 2) 在对应业务 API 项目加 controller; 3) 在 OperationsDashboardPage 替换占位 Empty 为实际 chart (Recharts/Statistic). 长期方向: Phase 3 数据中台 → Trino 联邦查询.',
    'pages.operations.operationsdashboardpage.3f525994': '运营看板',
    'pages.operations.operationsdashboardpage.52a57b7e': '占位模块',
    'pages.operations.operationsdashboardpage.660e1360': '如何接入新数据源?',
    'pages.operations.operationsdashboardpage.70f31b9c': '数据接入中, 敬请期待',
    'pages.operations.operationsdashboardpage.9c93433c':
      '综合显示公司整体运营情况 — 销售 / 研发 / 生产 / 供应链 / 库存 / 交付',
    'pages.operations.operationsdashboardpage.dd945db1':
      '当前为预留版块, 数据接入按业务排期分批推进. 6 个维度对应公司核心业务流, 后续将逐步接入 SAP / MES / Jira / iws_deliverproject 等数据源.',
    'pages.opportunity.opportunitycreatemodal.da0e789a': '暂缓',
    'pages.opportunity.opportunitycreatemodal.e2fd47a2': '正在进行',
    'pages.opportunity.opportunitydetailpage.0a944d46': '审核通过？',
    'pages.opportunity.opportunitydetailpage.18b480fd':
      "该商机暂无报价单 — 点击右上角'+ 新建报价'快速创建",
    'pages.opportunity.opportunitydetailpage.19584257': '样机测试完成？',
    'pages.opportunity.opportunitydetailpage.1ab13cc2': '进行中',
    'pages.opportunity.opportunitydetailpage.29106709': '审批通过',
    'pages.opportunity.opportunitydetailpage.2aba701e': '确认输单',
    'pages.opportunity.opportunitydetailpage.33ff9156': '确认立项审批通过',
    'pages.opportunity.opportunitydetailpage.394f8bea': '销售预测',
    'pages.opportunity.opportunitydetailpage.4395f157': '单价',
    'pages.opportunity.opportunitydetailpage.481f341e': '通过',
    'pages.opportunity.opportunitydetailpage.482bc089': '确认',
    'pages.opportunity.opportunitydetailpage.5342a4a7': '提交样机测试申请',
    'pages.opportunity.opportunitydetailpage.542f6578': '拒绝申请？',
    'pages.opportunity.opportunitydetailpage.569d2fb1': '取消',
    'pages.opportunity.opportunitydetailpage.5f1d4c8e': '不支持回退到过往阶段',
    'pages.opportunity.opportunitydetailpage.5f2c228f': '新建报价',
    'pages.opportunity.opportunitydetailpage.622a8037': '审核通过',
    'pages.opportunity.opportunitydetailpage.6b988583': '未开始',
    'pages.opportunity.opportunitydetailpage.70f40f78': '样机测试',
    'pages.opportunity.opportunitydetailpage.7427768c': '赢单',
    'pages.opportunity.opportunitydetailpage.751f2a90': '总额',
    'pages.opportunity.opportunitydetailpage.79941986': '立项审批',
    'pages.opportunity.opportunitydetailpage.7f07399c': '项目立项',
    'pages.opportunity.opportunitydetailpage.80dd19c7': '已完成',
    'pages.opportunity.opportunitydetailpage.81706428': '修改时间',
    'pages.opportunity.opportunitydetailpage.826385b7': '样机申请',
    'pages.opportunity.opportunitydetailpage.84251272': '报价名称',
    'pages.opportunity.opportunitydetailpage.88f5d6bf': '已拒绝',
    'pages.opportunity.opportunitydetailpage.8bd1fd2f': '拒绝',
    'pages.opportunity.opportunitydetailpage.8dad366f': '附件',
    'pages.opportunity.opportunitydetailpage.8f9c36c6': '需求收集',
    'pages.opportunity.opportunitydetailpage.919297bf': '已审核',
    'pages.opportunity.opportunitydetailpage.92fa4f13': '请简述输单原因（可选）',
    'pages.opportunity.opportunitydetailpage.93beaaf2': '保密协议',
    'pages.opportunity.opportunitydetailpage.ndaSkippable': '保密协议（可跳过）',
    'pages.opportunity.opportunitydetailpage.ndaSkipHint':
      '国内商机已跳过保密协议，直接推进到需求收集',
    'pages.opportunity.opportunitydetailpage.a3eed542': '产品行项目',
    'pages.opportunity.opportunitydetailpage.aab512c1': '输单',
    'pages.opportunity.opportunitydetailpage.b179d90c': '该商机暂无产品行',
    'pages.opportunity.opportunitydetailpage.b35228c1': '小计',
    'pages.opportunity.opportunitydetailpage.b44aeb3b': '产品',
    'pages.opportunity.opportunitydetailpage.c2202fdd': '商机关闭',
    'pages.opportunity.opportunitydetailpage.cb649758': '商务谈判',
    'pages.opportunity.opportunitydetailpage.d1aac823': '✓ 立项审批通过',
    'pages.opportunity.opportunitydetailpage.d4a8687a': '数量',
    'pages.opportunity.opportunitydetailpage.d7351f57': '编号',
    'pages.opportunity.opportunitydetailpage.da35bcef': '销售技术支持协作',
    'pages.opportunity.opportunitydetailpage.dc42c4c8': '报价单',
    'pages.opportunity.opportunitydetailpage.notesTab': '项目进展',
    'pages.opportunity.opportunitydetailpage.e2fcfd87': '标记输单',
    'pages.opportunity.opportunitydetailpage.e5f7d2db': '💡 点击未来阶段的圆圈以推进',
    'pages.opportunity.opportunitydetailpage.e7a201ed': '已赢单',
    'pages.opportunity.opportunitydetailpage.ed5098cf': '进行中',
    'pages.opportunity.opportunitydetailpage.eef87286': '确认标记为已赢单',
    'pages.opportunity.opportunitydetailpage.ef889c19': '◯ 待立项审批',
    'pages.opportunity.opportunitydetailpage.efa6c136': '样机流程',
    'pages.opportunity.opportunitydetailpage.f5dfb8d4': '提交样机测试申请',
    'pages.opportunity.opportunitydetailpage.f774e7c2': '完成',
    'pages.opportunity.opportunitydetailpage.f9af59b5': '完成样机测试',
    'pages.opportunity.opportunitynotestab.empty': '暂无项目进展记录',
    'pages.opportunity.opportunitynotestab.create': '新建',
    'pages.opportunity.opportunitynotestab.pinned': '置顶',
    'pages.opportunity.opportunitynotestab.refresh': '刷新',
    'pages.opportunity.opportunitynotestab.title': '项目进展记录',
    'pages.opportunity.opportunitynotestab.unknownAuthor': '未知用户',
    'pages.opportunity.opportunitydetailpage.fd97f6c6': '提交',
    'pages.opportunity.opportunitydetailpage.ffdd6dc3': '已输单',
    'pages.opportunity.stageadvancemodal.0557016e': '当前阶段需补充字段',
    'pages.opportunity.stageadvancemodal.13f344eb': 'OA 状态',
    'pages.opportunity.stageadvancemodal.1965514e': '样机测试',
    'pages.opportunity.stageadvancemodal.215273a5': '商机关闭',
    'pages.opportunity.stageadvancemodal.2fffb90b': '下一阶段预计结束日期',
    'pages.opportunity.stageadvancemodal.32e44d92': '当前阶段',
    'pages.opportunity.stageadvancemodal.461ef383': '目标阶段',
    'pages.opportunity.stageadvancemodal.5586cee4': '推进 BPF 阶段',
    'pages.opportunity.stageadvancemodal.56ded777': '商务谈判',
    'pages.opportunity.stageadvancemodal.6956d5aa': '确认推进',
    'pages.opportunity.stageadvancemodal.6d724f1b': '立项审批',
    'pages.opportunity.stageadvancemodal.797bab60': '是否启动样机测试',
    'pages.opportunity.stageadvancemodal.957a8cdd': '需求收集',
    'pages.opportunity.stageadvancemodal.9b6d9ef5': '预计收入',
    'pages.opportunity.stageadvancemodal.9cec40a1': '样机测试截止日期',
    'pages.opportunity.stageadvancemodal.af35f9d1': '未启动',
    'pages.opportunity.stageadvancemodal.b722aed6': '保密协议',
    'pages.opportunity.stageadvancemodal.c1c32b4b': '样机申请',
    'pages.opportunity.stageadvancemodal.d7c138b8': '项目立项',
    'pages.opportunity.stageadvancemodal.dac80f16': '下一阶段计划',
    'pages.opportunity.stageadvancemodal.e7881be1': '请填写下一阶段预计结束日期',
    'pages.opportunity.stageadvancemodal.eb49cc39': '总结结论',
    'pages.opportunity.stageadvancemodal.f85285ff': '取消',
    'pages.pricing.pricingpages.e37b9537': '搜索 名称 / 型号',
    'pages.quote.quotecreatemodal.4cbbe265': '国内',
    'pages.quote.quotecreatemodal.70f8bf64': '海外',
    'pages.quote.quotedetailpage.0572baa1': '产品行项目',
    'pages.quote.quotedetailpage.13cd594c': '转 SAP 销售凭证 (ZSDIF017)',
    'pages.quote.quotedetailpage.13e5f371': '系统自动校验',
    'pages.quote.quotedetailpage.1435b68a': '确认推送',
    'pages.quote.quotedetailpage.17c283f8': '自动推进',
    'pages.quote.quotedetailpage.23e88389': '经理审批',
    'pages.quote.quotedetailpage.2d2a1f7f': '总监审批',
    'pages.quote.quotedetailpage.2fdbc3f7': '激活',
    'pages.quote.quotedetailpage.37e727a3': '运费审核',
    'pages.quote.quotedetailpage.3912b99c': '草稿',
    'pages.quote.quotedetailpage.605cf536': '系统信息',
    'pages.quote.quotedetailpage.60f3fd34':
      '根据签约公司选择对应的报价单 PDF 模板（不同公司有不同抬头/页脚/币种',
    'pages.quote.quotedetailpage.64f21964': '替换',
    'pages.quote.quotedetailpage.6c5bc8b9': '取消',
    'pages.quote.quotedetailpage.7240ff1c': '推进阶段',
    'pages.quote.quotedetailpage.77e467c3': '已接受',
    'pages.quote.quotedetailpage.7dfc87d1': '从 BOQ 同步产品',
    'pages.quote.quotedetailpage.87cc37fe': '选择 PDF 模板',
    'pages.quote.quotedetailpage.892323f1': '合规审核',
    'pages.quote.quotedetailpage.8b9a4cca': '已接受',
    'pages.quote.quotedetailpage.8d05a975': '追加',
    'pages.quote.quotedetailpage.8e9db337': '关闭',
    'pages.quote.quotedetailpage.905befbd': '转 SAP 销售凭证',
    'pages.quote.quotedetailpage.98d86244': '当前流程',
    'pages.quote.quotedetailpage.9aa0610f': '报价信息',
    'pages.quote.quotedetailpage.a0c0cc2e': '按条件自动跳过 Freight / Director Approve',
    'pages.quote.quotedetailpage.a349ea0b': '已发送',
    'pages.quote.quotedetailpage.a77b2dbb': '下载',
    'pages.quote.quotedetailpage.aad48535': '激活',
    'pages.quote.quotedetailpage.b0f81672': '推进 BPF 阶段',
    'pages.quote.quotedetailpage.b3306398': 'PDF 已下载',
    'pages.quote.quotedetailpage.c4446511': '概要',
    'pages.quote.quotedetailpage.c69e445f':
      '异步入队 — SAP 处理完成后回写 VBELN。重复点击不会重复传 (走更新路径)。',
    'pages.quote.quotedetailpage.c793035b': '同步',
    'pages.quote.quotedetailpage.cb644515': '定价审核',
    'pages.quote.quotedetailpage.ccb96a97': '未启动',
    'pages.quote.quotedetailpage.d424b5f2': '价格查询',
    'pages.quote.quotedetailpage.d4f1d6f3': '目标阶段',
    'pages.quote.quotedetailpage.dd117807': '金额',
    'pages.quote.quotedetailpage.eb01af51': '当前阶段',
    'pages.quote.quotedetailpage.eea2eb42': '推进',
    'pages.quote.quotedetailpage.f57ea53a': '价格审核',
    'pages.quote.quotedetailpage.ff0abbae': '下载 PDF',
    'pages.sinosure.sinosurecreatemodal.8253bf63': '例: T',
    'pages.sinosure.sinosuredetailpage.06d1f7a0': '中信保流程',
    'pages.sinosure.sinosuredetailpage.0781693b': '资料审核',
    'pages.sinosure.sinosuredetailpage.0ca3650a': '推进 BPF 阶段',
    'pages.sinosure.sinosuredetailpage.0e42dbbd': '推进阶段',
    'pages.sinosure.sinosuredetailpage.200ba928': '目标阶段',
    'pages.sinosure.sinosuredetailpage.21ec1d84': '未启动',
    'pages.sinosure.sinosuredetailpage.25a41019': '当前阶段',
    'pages.sinosure.sinosuredetailpage.294a16ad': '中信保审批',
    'pages.sinosure.sinosuredetailpage.62af2156': '审批信息',
    'pages.sinosure.sinosuredetailpage.6ac07778': '取消',
    'pages.sinosure.sinosuredetailpage.8d8d1f8e': '系统信息',
    'pages.sinosure.sinosuredetailpage.93874381': '推进',
    'pages.sinosure.sinosuredetailpage.951bfef3': '资料准备',
    'pages.sinosure.sinosuredetailpage.9c23dde8': '中信保信息',
    'pages.sinosure.sinosuredetailpage.b6a0f402': '中信保资料',
    'pages.sinosure.sinosuredetailpage.b84c2dc5': '完成',
    'pages.sinosure.sinosuredetailpage.c00bfadf': '概要',
    'pages.sinosure.sinosuredetailpage.f21579d4': '资料附件',
    'pages.worklist.worklistpage.42e7c8a0': '工作列表',
    'pages.worklist.worklistpage.d635b169': '暂无未完成事项',
  },
  en: {
    'dynamic.appCount': '{{count}} app',
    'dynamic.appCount_plural': '{{count}} apps',
    'dynamic.appCenterSummary':
      '{{total}} apps · {{live}} live · {{planned}} planned · {{integrations}} integrations',
    'dynamic.appCenterNoMatch': 'No apps match "{{keyword}}"',
    'dynamic.itemCount': '{{count}} app',
    'dynamic.itemCount_plural': '{{count}} apps',
    'dynamic.agentToolSummary':
      '{{count}} agent tools auto-registered via @AgentTool decorator · Phase 2 for LangGraph LLM',
    'dynamic.agentToolNoMatch': 'No tools match "{{keyword}}"',
    'dynamic.agentToolEmpty': 'No registered AgentTools',
    'dynamic.toolCount': '{{count}} tool',
    'dynamic.toolCount_plural': '{{count}} tools',
    'dynamic.namespaceCount': '{{count}} namespace',
    'dynamic.namespaceCount_plural': '{{count}} namespaces',
    'dynamic.linkedRoles': 'Linked {{count}} roles',
    'dynamic.fspFields': 'Fields ({{count}})',
    'dynamic.fspRoles': 'Roles ({{count}})',
    'dynamic.settingsSummary': '{{count}} items · System dictionaries & base config',
    'dynamic.rolePrivilegeSaved':
      'Saved — added {{added}}, updated {{updated}}, removed {{removed}}',
    'dynamic.savePrivilegeChanges': 'Save ({{count}} changes)',
    'dynamic.assignmentSummary': '{{total}} total · {{granted}} granted',
    'dynamic.paginationRange': '{{start}}-{{end}} of {{total}}',
    'dynamic.updateSapDocTitle': 'Update SAP Sales Doc (VBELN: {{vbeln}})',
    'dynamic.sapQueued': 'Queued ({{mode}}) jobId={{jobId}}...',
    'dynamic.sapModeUpdate': 'update',
    'dynamic.sapModeCreate': 'create',
    'dynamic.updateSapButton': 'Update SAP ({{vbeln}})',
    'components.admincrudpage.01237d41': 'Created',
    'components.admincrudpage.0f11a330': 'Cancel',
    'components.admincrudpage.2f1e2ff9': 'Deleted',
    'components.admincrudpage.47e49f2d': 'Create',
    'components.admincrudpage.49979665': 'Delete?',
    'components.admincrudpage.539443b5': 'New',
    'components.admincrudpage.6e6a9139': 'Save',
    'components.admincrudpage.86e97d5f': 'Edit',
    'components.admincrudpage.bd1a2c41': 'Updated',
    'components.attachmentlist.6a4a289c':
      'A category picker opens on upload. Multi-file batch supported. Max 10MB per file.',
    'components.attachmentlist.775f084e': 'Choose Document Category',
    'components.attachmentlist.88186e58': 'Attachments',
    'components.attachmentlist.9716a894': ' — Click or drag to upload',
    'components.attachmentlist.bb9d8c69': 'No attachments',
    'components.attachmentlist.d652c433': '',
    'components.attachmentlist.e90a36ac':
      ' file(s) ready to upload. Choose a category (applies to all files in this batch; you can view / delete each file after upload):',
    'components.exportbutton.2788067f': 'Downloaded',
    'components.exportbutton.2e0253bf': 'Export',
    'components.multipresalessubgrid.221a644d': 'Sales Technical Support Engineer',
    'components.multipresalessubgrid.3cac4655': 'Start',
    'components.multipresalessubgrid.76dc7c62': 'Other',
    'components.multipresalessubgrid.7a101ff9': 'End',
    'components.multipresalessubgrid.9be58af0': 'Role',
    'components.multipresalessubgrid.affc5965': 'Product Specialist',
    'components.multipresalessubgrid.b7d8e7cd': 'Solution Architect',
    'components.multipresalessubgrid.c3d9980c': 'Consultant',
    'components.multipresalessubgrid.c6771690': 'Support Period',
    'components.multipresalessubgrid.e43a18f0': 'User',
    'components.multipresalessubgrid.ec82a182': 'Auto Grants',
    'components.notificationbell.b775cfe8': 'Realtime',
    'components.pricelookup.027e10b4': 'All Matches',
    'components.pricelookup.126c0b09': 'Qty',
    'components.pricelookup.1353db1c': 'Discounted',
    'components.pricelookup.1ff4854f': 'List',
    'components.pricelookup.5207b105': 'Domestic',
    'components.pricelookup.5daf1dd5': 'Subclass',
    'components.pricelookup.62f5aeed': 'Lookup',
    'components.pricelookup.6467edf2': 'Margin',
    'components.pricelookup.6815ef6c': 'Floor',
    'components.pricelookup.849c97d5': 'Country',
    'components.pricelookup.ab2fd02e': 'Model',
    'components.pricelookup.d86f1b03': 'Lookup Parameters',
    'components.pricelookup.e9a9fa69': 'Overseas',
    'components.pricelookup.ef792a83': 'Base',
    'components.quickcreate.10c4f4f0': 'Account Name',
    'components.quickcreate.182027db': 'Quick Create',
    'components.quickcreate.2092add1': 'Account',
    'components.quickcreate.2bfe7b0a': 'Company',
    'components.quickcreate.49de1b83': 'Subject',
    'components.quickcreate.606723b2': 'Phone',
    'components.quickcreate.634f6c1b': 'Last Name',
    'components.quickcreate.68983c0b': 'Job Title',
    'components.quickcreate.8a1ba983': 'Account Number',
    'components.quickcreate.8d98732d': 'First Name',
    'components.quickcreate.9b7dcd18': 'Contact',
    'components.quickcreate.ae9ef22c': 'Account',
    'components.quickcreate.b85b9e64': 'Mobile',
    'components.quickcreate.bed46160': 'Email',
    'components.quickcreate.e1c34658': 'Website',
    'components.quickcreate.ee650671': 'Subject',
    'components.salesforecastsubgrid.1bd9aa34': 'Comments',
    'components.salesforecastsubgrid.214d40ee': 'Quantity',
    'components.salesforecastsubgrid.2c31b92d': 'Frequency Band',
    'components.salesforecastsubgrid.2cbff4f1': 'Unit Price',
    'components.salesforecastsubgrid.6d48ebd6': 'Class',
    'components.salesforecastsubgrid.8151df00': 'Subclass',
    'components.salesforecastsubgrid.b38dbb7d': 'Total',
    'layout.applayout.48d19dad': 'Welcome, ',
    'layout.applayout.48dc23eb': 'Default menu (sitemap not configured)',
    'layout.applayout.sitemapLoadFailed': 'Menu failed to load. Please refresh and try again.',
    'layout.applayout.sitemapLoading': 'Loading menu...',
    'layout.applayout.d3fc5db4': 'Sign out',
    'layout.appswitcher.f8ab9259': 'Please select an app',
    'pages.account.accountcreatemodal.28ea6385': 'No files selected',
    'pages.account.accountcreatemodal.d0c3718b':
      'Office / TXT files are supported and will be uploaded automatically after the account is created',
    'pages.account.accountdetailpage.03226901': 'Address 2',
    'pages.account.accountdetailpage.0bc70d10': 'Billing',
    'pages.account.accountdetailpage.0ed3074f': 'Submit',
    'pages.account.accountdetailpage.39691604': 'Shipping',
    'pages.account.accountdetailpage.5cd8d2bb': 'Contact Preferences',
    'pages.account.accountdetailpage.86e1e37a': 'Account Information',
    'pages.account.accountdetailpage.8a3f29e9': 'System',
    'pages.account.accountdetailpage.905018df': 'Files',
    'pages.account.accountdetailpage.92406ebe': 'Summary',
    'pages.account.accountdetailpage.ab4b4b81': 'Company Profile',
    'pages.account.accountdetailpage.b8af1d85': 'SAP Extended Fields',
    'pages.account.accountdetailpage.c9dd7e89': 'Address',
    'pages.account.accountdetailpage.dc168816': 'Marketing',
    'pages.account.accountdetailpage.e1beb8f3': 'Sync to SAP',
    'pages.account.accountdetailpage.eed2eba9': 'Logistics & Finance',
    'pages.account.accountdetailpage.f133710d': 'Description',
    'pages.account.accountdetailpage.f2911700': 'SAP',
    'pages.account.accountdetailpage.f69608c0': 'Cancel Submission',
    'pages.admin.adminuserspage.07f977b4': 'Roles',
    'pages.admin.adminuserspage.0b131f60': 'Cancel',
    'pages.admin.adminuserspage.0cb05934': 'Enable User?',
    'pages.admin.adminuserspage.1697a1bc': 'Active',
    'pages.admin.adminuserspage.17cfbbd0': 'Confirm',
    'pages.admin.adminuserspage.2f0008a4': 'Full Name',
    'pages.admin.adminuserspage.42e5b836': 'User Management',
    'pages.admin.adminuserspage.750d8a77': 'Users',
    'pages.admin.adminuserspage.85c5cb55': 'Disabled',
    'pages.admin.adminuserspage.a9d032b9': 'Disable User?',
    'pages.admin.adminuserspage.ada9cdbe': 'Available Roles',
    'pages.admin.adminuserspage.b348315f': 'Email',
    'pages.admin.adminuserspage.d0cf70a8': 'BU',
    'pages.admin.adminuserspage.e6ddfbbd': 'Assigned Roles',
    'pages.admin.appcenterpage.15013820': 'Search apps / tags',
    'pages.admin.appcenterpage.29849f31': 'ETA',
    'pages.admin.appcenterpage.9eb59229':
      'Contact super admin — sub-apps mount via manifest JSON + sitemap config (plugin architecture in Phase 2 roadmap)',
    'pages.admin.appcenterpage.b29cfd52': 'Application Center',
    'pages.admin.appcenterpage.c1f369f8': 'How to onboard a new app?',
    'pages.admin.bulkassignrolesmodal.3ed28929': 'Roles',
    'pages.admin.bulkassignrolesmodal.755dc6ac': 'Revoke',
    'pages.admin.bulkassignrolesmodal.87be5c22': 'Mode',
    'pages.admin.bulkassignrolesmodal.de973ef2': 'Assign',
    'pages.admin.bulkassignrolesmodal.f7d3cde3': 'Replace',
    'pages.admin.butreepage.0efeca48': 'Name',
    'pages.admin.butreepage.301d2ad8': 'Division',
    'pages.admin.butreepage.7b4601b8': 'Email',
    'pages.admin.butreepage.8e667fe5': 'Cost Center',
    'pages.admin.butreepage.f8d0ec76': 'Enterprise Organization',
    'pages.admin.createrolemodal.0dd8707b': 'System — IT / sysadmin',
    'pages.admin.createrolemodal.97edd3e1': 'Reviewer — Approval staff',
    'pages.admin.createrolemodal.9e48a5da': 'Description',
    'pages.admin.createrolemodal.c0277b71': 'Admin — Manager / Director / VP',
    'pages.admin.createrolemodal.d27efee7': 'Business — Sales / Ops staff',
    'pages.admin.createrolemodal.d4eb4d2b': 'Type',
    'pages.admin.createrolemodal.d5761590': 'Name',
    'pages.admin.createrolemodal.dc4a45ea': 'Title',
    'pages.admin.createusermodal.90984ef9': 'Full Name',
    'pages.admin.createusermodal.95ad87df': 'Email',
    'pages.admin.createusermodal.987a2667': 'Initial Roles',
    'pages.admin.createusermodal.b38defc1': 'Multi',
    'pages.admin.createusermodal.b8a81f06': 'Domain Name',
    'pages.admin.createusermodal.e2395cb8': 'Password',
    'pages.admin.createusermodal.e3e67201': 'BU',
    'pages.admin.fspdetaildrawer.00c92668': 'Entity',
    'pages.admin.fspdetaildrawer.051533f3': 'Select roles',
    'pages.admin.fspdetaildrawer.07bd9fba': 'Description',
    'pages.admin.fspdetaildrawer.0d887427': 'Delete',
    'pages.admin.fspdetaildrawer.1fdcd7ef':
      'Select roles that should apply this FSP (multi; effective immediately after save, 5min cache)',
    'pages.admin.fspdetaildrawer.2d73563c': 'Create',
    'pages.admin.fspdetaildrawer.2e19c086': 'roles',
    'pages.admin.fspdetaildrawer.3bd1d0fa': 'Entity name',
    'pages.admin.fspdetaildrawer.49c0259b': 'Read',
    'pages.admin.fspdetaildrawer.4cb95ee8': 'Update',
    'pages.admin.fspdetaildrawer.5f5b367e': 'Confirm delete?',
    'pages.admin.fspdetaildrawer.62d7cd7e': 'Please fill entity and field',
    'pages.admin.fspdetaildrawer.6e89346f': 'Cancel',
    'pages.admin.fspdetaildrawer.73befbb7': 'General',
    'pages.admin.fspdetaildrawer.7839c51a': 'Name',
    'pages.admin.fspdetaildrawer.7b8407d6': 'fields',
    'pages.admin.fspdetaildrawer.7c5f525b': 'Save failed',
    'pages.admin.fspdetaildrawer.9156c851': 'Save',
    'pages.admin.fspdetaildrawer.99072325': 'Save Links',
    'pages.admin.fspdetaildrawer.9e5719cf': 'Field permission added',
    'pages.admin.fspdetaildrawer.a71b02df': 'Field',
    'pages.admin.fspdetaildrawer.c1532d8c': 'Delete failed',
    'pages.admin.fspdetaildrawer.c70468d1': 'Removed',
    'pages.admin.fspdetaildrawer.ca663086': 'Saved',
    'pages.admin.fspdetaildrawer.cbead127': 'Add failed',
    'pages.admin.fspdetaildrawer.d39e1073': 'Add',
    'pages.admin.fspdetaildrawer.d50425e0': 'Field name',
    'pages.admin.fspdetaildrawer.e6b79944': 'Builtin',
    'pages.admin.fspdetaildrawer.fd70a5f0': 'FSP Detail',
    'pages.admin.fsplistpage.11825369': 'FSP created',
    'pages.admin.fsplistpage.16c0f5ac': 'Create',
    'pages.admin.fsplistpage.27e68f15': 'Create failed',
    'pages.admin.fsplistpage.3fbd7515': 'Builtin',
    'pages.admin.fsplistpage.444baaba': 'Roles',
    'pages.admin.fsplistpage.527553a2': 'No FSP configured',
    'pages.admin.fsplistpage.66528e9c': 'Click "Create" to add',
    'pages.admin.fsplistpage.6734022b': 'Search name',
    'pages.admin.fsplistpage.6a209a04': 'Fields',
    'pages.admin.fsplistpage.756e9999': 'Description',
    'pages.admin.fsplistpage.80d311ec': 'Please enter FSP name',
    'pages.admin.fsplistpage.974a49eb': 'Name',
    'pages.admin.fsplistpage.b8f956b4': 'Search',
    'pages.admin.fsplistpage.b9ab4d36': 'Refresh',
    'pages.admin.fsplistpage.cc8ff5c5': 'New FSP name',
    'pages.admin.fsplistpage.d545b5f9': 'Configure visible/editable fields per role',
    'pages.admin.fsplistpage.fc7eff36': 'Field Security Profiles',
    'pages.admin.notifyhistorypage.15148342': 'Mail Notifications',
    'pages.admin.notifyhistorypage.5c4f7674': 'Test Send',
    'pages.admin.notifyhistorypage.c3a6c0a7': 'Time',
    'pages.admin.notifyhistorypage.e86ec937': 'Test sent',
    'pages.admin.notifyhistorypage.fdef161a': 'Send',
    'pages.admin.roledetaildrawer.0141adb4': 'Builtin role — privileges read-only',
    'pages.admin.roledetaildrawer.24046374': 'Business',
    'pages.admin.roledetaildrawer.3de149c9': 'Privilege',
    'pages.admin.roledetaildrawer.3ececf03': 'Save',
    'pages.admin.roledetaildrawer.48fedf10': 'Load privileges failed',
    'pages.admin.roledetaildrawer.5680a4c4': 'App Access',
    'pages.admin.roledetaildrawer.5aa3421a': 'Save Menu',
    'pages.admin.roledetaildrawer.681da459': 'Privileges',
    'pages.admin.roledetaildrawer.6bbbf35a': 'Save Apps',
    'pages.admin.roledetaildrawer.6eb40301': 'Search privilege',
    'pages.admin.roledetaildrawer.6f5d885a': 'changed',
    'pages.admin.roledetaildrawer.77506a2a': 'Admin',
    'pages.admin.roledetaildrawer.8842a540': 'Depth',
    'pages.admin.roledetaildrawer.depthBasic': 'Basic',
    'pages.admin.roledetaildrawer.depthDeep': 'Deep',
    'pages.admin.roledetaildrawer.depthGlobal': 'Global',
    'pages.admin.roledetaildrawer.depthLocal': 'Local',
    'pages.admin.roledetaildrawer.a591b62a': 'No matching privileges',
    'pages.admin.roledetaildrawer.aa38675d': 'Save failed',
    'pages.admin.roledetaildrawer.b57db90b': 'changes',
    'pages.admin.roledetaildrawer.bfc11382': 'System',
    'pages.admin.roledetaildrawer.dd13acfc': 'Reviewer',
    'pages.admin.roledetaildrawer.e05809ab': 'Title',
    'pages.admin.roledetaildrawer.ee336179': 'None',
    'pages.admin.settingshubpage.3a6f65d5': 'Parameter Configuration',
    'pages.admin.settingspages.04983a9a': 'Recipients',
    'pages.admin.settingspages.0bcff807': 'Name',
    'pages.admin.settingspages.0cce9698': 'Region',
    'pages.admin.settingspages.0e895da8': 'Name',
    'pages.admin.settingspages.1353ff2f': 'Source Name',
    'pages.admin.settingspages.18d48309': 'Mapping Name',
    'pages.admin.settingspages.201a91e2': 'Model',
    'pages.admin.settingspages.21cc6701': 'Manager',
    'pages.admin.settingspages.2b2d384a': 'Source Code',
    'pages.admin.settingspages.2d72ead4': 'Name',
    'pages.admin.settingspages.321d6a50': 'Signing Entity',
    'pages.admin.settingspages.34942e7e': 'ISO Code',
    'pages.admin.settingspages.3ad08a91': 'Code',
    'pages.admin.settingspages.44c9ad52': 'Continent',
    'pages.admin.settingspages.49ae47b7': 'Signing Entity',
    'pages.admin.settingspages.4b03b3b8': 'Country',
    'pages.admin.settingspages.544ae29d': 'Model Series',
    'pages.admin.settingspages.62b4389b': 'Name',
    'pages.admin.settingspages.69038513': 'Symbol',
    'pages.admin.settingspages.77cfc255': 'End Time',
    'pages.admin.settingspages.78445cc8': 'Name',
    'pages.admin.settingspages.899a82e1': 'Authorized',
    'pages.admin.settingspages.8d66b9ba': 'Start Time',
    'pages.admin.settingspages.93f0200d': 'Rate',
    'pages.admin.settingspages.946a7b63': 'Description',
    'pages.admin.settingspages.class_parent_group': 'Parent Group',
    'pages.admin.settingspages.class_subclass_count': 'Sub-class Count',
    'pages.admin.settingspages.group_class_count': 'Class Count',
    'pages.admin.settingspages.subclass_parent_class': 'Parent Class',
    'pages.admin.settingspages.subclass_parent_group': 'Parent Group',
    'pages.admin.settingspages.filter_by_group': 'Filter by Group',
    'pages.admin.settingspages.filter_by_class': 'Filter by Class',
    'pages.admin.settingspages.only_unlinked': 'Unlinked Only',
    'pages.admin.settingspages.9925f04f': 'Role',
    'pages.admin.settingspages.9955cccc': 'Code',
    'pages.admin.settingspages.99b212b9': 'English Name',
    'pages.admin.settingspages.9bd3aa9f': 'Phone Code',
    'pages.admin.settingspages.9c240348': 'Address',
    'pages.admin.settingspages.a1021b0b': 'Value',
    'pages.admin.settingspages.a6be3b91': 'Office Name',
    'pages.admin.settingspages.aed67b52': 'Key',
    'pages.admin.settingspages.c161d2bb': 'Division',
    'pages.admin.settingspages.c2a38303': 'Language',
    'pages.admin.settingspages.c4f06c14': 'Website',
    'pages.admin.settingspages.dea8a339': 'Code',
    'pages.admin.settingspages.e791860f': 'Category',
    'pages.admin.settingspages.ebd5d61b': 'Business Function',
    'pages.admin.settingspages.ee995b35': 'Value',
    'pages.admin.settingspages.efb21ff3': 'Part Number',
    'pages.admin.settingspages.f1743e59': 'Email',
    'pages.admin.settingspages.f76a23ee': 'Key',
    'pages.admin.settingspages.fcfb02ff': 'Chinese Name',
    'pages.contact.contactcreatemodal.403bcd67': 'Phone',
    'pages.contact.contactcreatemodal.4905f98e': 'Full Name',
    'pages.contact.contactcreatemodal.4b316048': 'No files selected',
    'pages.contact.contactcreatemodal.4c9cab4d': 'Address',
    'pages.contact.contactcreatemodal.6ef74b5f':
      'Office / TXT files are supported and will be uploaded automatically after the contact is created',
    'pages.contact.contactcreatemodal.c6148052': 'Any',
    'pages.contact.contactcreatemodal.c7945116': 'Mail',
    'pages.contact.contactcreatemodal.c884d020': 'Personal',
    'pages.contact.contactcreatemodal.e3b99d6b': 'Notes',
    'pages.contact.contactcreatemodal.e8a12d61': 'Communication Preferences',
    'pages.contact.contactcreatemodal.ea38fb39': 'Email',
    'pages.contact.contactcreatemodal.f8c958a2': 'More Contact',
    'pages.contact.contactcreatemodal.fd739909': 'Fax',
    'pages.contact.contactdetailpage.68a6467c': 'Summary',
    'pages.contact.contactdetailpage.6d28c558': 'Files',
    'pages.dashboard.salesdashboardpage.02ea5c1e': 'Won (YTD)',
    'pages.dashboard.salesdashboardpage.15e3ba17': 'Stage SLA',
    'pages.dashboard.salesdashboardpage.23224099': 'Top 5 Opportunities',
    'pages.dashboard.salesdashboardpage.2b1a2f31': 'Won (Month)',
    'pages.dashboard.salesdashboardpage.95ca2715': 'Weighted',
    'pages.dashboard.salesdashboardpage.a97e08cb': 'Pipeline Funnel',
    'pages.dashboard.salesdashboardpage.dd5e4c6f': 'Active Pipeline',
    'pages.delivery.deliverydetailpage.08a8a9e7': 'Execution',
    'pages.delivery.deliverydetailpage.1775a646': 'Accepted',
    'pages.delivery.deliverydetailpage.2143bef1': 'Pending',
    'pages.delivery.deliverydetailpage.25f8f103': 'Rejected',
    'pages.delivery.deliverydetailpage.3f13a842': 'In Progress',
    'pages.delivery.deliverydetailpage.53b95577': 'Acceptance',
    'pages.delivery.deliverydetailpage.6bff7bff': 'Team',
    'pages.delivery.deliverydetailpage.79ed48d3': 'Project Information',
    'pages.delivery.deliverydetailpage.7e866511': 'Closeout',
    'pages.delivery.deliverydetailpage.8bb34e1a': 'Kickoff',
    'pages.delivery.deliverydetailpage.abc0217b': 'System',
    'pages.delivery.deliverydetailpage.c1705459': 'Project Progress',
    'pages.delivery.deliverydetailpage.dba5c7e6': 'Summary',
    'pages.entity.entitydetailpage.1390ef07': 'Discard',
    'pages.entity.entitydetailpage.1c686a46': 'Cancel',
    'pages.entity.entitydetailpage.3987c4b9': 'Unsaved edits will be lost',
    'pages.entity.entitydetailpage.5109db70': 'Summary',
    'pages.entity.entitydetailpage.5482b4c7': 'General Information',
    'pages.entity.entitydetailpage.5ab29c65': 'Read Only',
    'pages.entity.entitydetailpage.61623b72': 'Keep editing',
    'pages.entity.entitydetailpage.8d70e6cd': 'Refresh',
    'pages.entity.entitydetailpage.93680c16': 'Edit',
    'pages.entity.entitydetailpage.b6f83ec8': 'Discard changes?',
    'pages.entity.entitydetailpage.e10cf4cb': 'Save',
    'pages.inbox.inboxpage.3a1bb433': 'Approval Inbox',
    'pages.inbox.inboxpage.3be669e2': 'Approve',
    'pages.inbox.inboxpage.5798fb3c': 'Approve',
    'pages.inbox.inboxpage.6a194bef': 'Comment (optional)',
    'pages.inbox.inboxpage.7339d6ed': 'Pending',
    'pages.inbox.inboxpage.74a547c5': 'Reject',
    'pages.inbox.inboxpage.7d05dbd0': 'Approved, amount reasonable.',
    'pages.inbox.inboxpage.a01f27cb': 'Bulk Reject',
    'pages.inbox.inboxpage.c03b1d13': 'Bulk Approve',
    'pages.inbox.inboxpage.c8a9119c': 'Exceeds limit, please resubmit.',
    'pages.inbox.inboxpage.cac4af0c': 'Rejected',
    'pages.inbox.inboxpage.cfc7c594': 'Reject',
    'pages.inbox.inboxpage.dfca8e8f': 'Approved',
    'pages.inbox.inboxpage.fc2a7583': 'Cancelled',
    'pages.lead.leadcreatemodal.490aca35': 'No files selected',
    'pages.lead.leadcreatemodal.79814209': 'Full Name',
    'pages.lead.leadcreatemodal.aeae3eeb':
      'Office / TXT files are supported and will be uploaded automatically after the lead is created',
    'pages.lead.leaddetailpage.1eed6a89': 'Qualify',
    'pages.lead.leaddetailpage.2c73c03c': 'Convert',
    'pages.lead.leaddetailpage.45ccf6be': 'Qualify Lead',
    'pages.lead.leaddetailpage.c02bc9c4': 'Qualified',
    'pages.lead.leaddetailpage.c11da8be': 'Opportunity',
    'pages.lead.leaddetailpage.c7e1861e': 'Account',
    'pages.lead.leaddetailpage.dcc960d3': 'Open',
    'pages.lead.leaddetailpage.e155cda1': 'Files',
    'pages.lead.leaddetailpage.f27d951b': 'Contact',
    'pages.lead.leaddetailpage.f64f2248': 'Disqualified',
    'pages.loginpage.56dfbedb': 'Sign in',
    'pages.loginpage.6224a9d1': 'Dev account: liuyayun@baicells.com / Crest@2026',
    'pages.loginpage.845973d5': 'Sign-in failed',
    'pages.loginpage.9336fb42': 'Password',
    'pages.loginpage.a14d3cc1': 'Username / Email',
    'pages.loginpage.agentPlatform': 'AI Agent Enterprise Operations Cockpit',
    'pages.loginpage.crmFooter': 'Baicells CRM Sales Center',
    'pages.loginpage.crmSalesCenter': 'CRM Sales Center',
    'pages.loginpage.erpFinanceCenter': 'ERP Finance Center',
    'pages.loginpage.erpFooter': 'Baicells ERP Finance Center',
    'pages.loginpage.dingtalkFailed': 'DingTalk sign-in failed. Please try again.',
    'pages.loginpage.dingtalkLogin': 'Continue with DingTalk',
    'pages.loginpage.dingtalkPending': 'Completing DingTalk sign-in...',
    'pages.loginpage.enterpriseIntel': 'Baicells Enterprise Intelligence',
    'pages.admin.butreepage.dingtalkSync': 'Sync DingTalk Org',
    'pages.admin.butreepage.dingtalkSyncDone':
      'DingTalk org sync completed: departments +{{deptCreated}} / updated {{deptUpdated}}; users +{{userCreated}} / updated {{userUpdated}}',
    'pages.admin.butreepage.dingtalkSyncFailed': 'DingTalk org sync failed',
    'pages.admin.butreepage.scheduleEvery6h': 'Every 6 hours',
    'pages.admin.butreepage.scheduleEvery12h': 'Every 12 hours',
    'pages.admin.butreepage.scheduleEvery24h': 'Daily',
    'pages.admin.butreepage.scheduleEvery168h': 'Weekly',
    'pages.admin.butreepage.notScheduled': 'Not set',
    'pages.admin.butreepage.scheduleSaved': 'Sync schedule saved',
    'pages.admin.butreepage.syncWarningTitle': 'Sync updates org, users, and account status',
    'pages.admin.butreepage.syncWarningDesc':
      'Run now pulls departments and users from DingTalk, then updates CREST enterprise organizations and user enablement from DingTalk data.',
    'pages.admin.butreepage.runNow': 'Run now',
    'pages.admin.butreepage.confirmSyncTitle': 'Run DingTalk org sync now?',
    'pages.admin.butreepage.confirmSyncDesc':
      'Sync usually takes tens of seconds. Avoid repeated clicks while it is running.',
    'pages.admin.butreepage.scheduleTitle': 'Scheduled sync',
    'pages.admin.butreepage.enableSchedule': 'Enable scheduled sync',
    'pages.admin.butreepage.saveSchedule': 'Save schedule',
    'pages.admin.butreepage.nextRun': 'Next run',
    'pages.admin.butreepage.lastRun': 'Last run',
    'pages.admin.butreepage.lastResult': 'Last result',
    'pages.admin.butreepage.showUsers': 'Show people',
    'pages.admin.butreepage.disabledUsers': 'Disabled {{count}}',
    'pages.admin.butreepage.dingtalkBound': 'DingTalk',
    'pages.admin.butreepage.syncSettingsTab': 'Sync settings',
    'pages.admin.butreepage.syncHistoryTab': 'Sync history',
    'pages.admin.butreepage.noSyncHistory': 'No sync history',
    'pages.admin.butreepage.syncStatusSuccess': 'Success',
    'pages.admin.butreepage.syncStatusFailed': 'Failed',
    'pages.admin.butreepage.syncStatusRunning': 'Running',
    'pages.admin.butreepage.triggerScheduled': 'System scheduled',
    'pages.admin.butreepage.triggerManual': 'Manual',
    'pages.admin.butreepage.showDiffs': 'View changes',
    'pages.admin.butreepage.hideDiffs': 'Hide changes',
    'pages.admin.butreepage.noActualChanges': 'No actual changes',
    'pages.admin.butreepage.changeSummaryLine':
      '{{total}} changes: {{users}} users, {{departments}} departments',
    'pages.admin.butreepage.entityDepartment': 'Department',
    'pages.admin.butreepage.entityUser': 'User',
    'pages.admin.butreepage.changeCreated': 'Created',
    'pages.admin.butreepage.changeUpdated': 'Updated',
    'pages.admin.butreepage.changeDisabled': 'Disabled',
    'pages.admin.butreepage.changeRestored': 'Restored',
    'pages.admin.butreepage.fieldFullName': 'Name',
    'pages.admin.butreepage.fieldEmail': 'Email',
    'pages.admin.butreepage.fieldAccount': 'Login account',
    'pages.admin.butreepage.fieldBusinessUnit': 'Enterprise Organization',
    'pages.admin.butreepage.fieldStatus': 'Status',
    'pages.admin.butreepage.fieldSyncState': 'DingTalk status',
    'pages.admin.butreepage.fieldDepartmentName': 'Department name',
    'pages.admin.butreepage.fieldParentDepartment': 'Parent department',
    'pages.admin.butreepage.fieldSortOrder': 'Sort order',
    'pages.admin.butreepage.emptyValue': 'Not set',
    'pages.admin.butreepage.statusActive': 'Active',
    'pages.admin.butreepage.statusDisabled': 'Disabled',
    'pages.admin.butreepage.statusDeparted': 'Departed',
    'pages.admin.butreepage.onlyMetadataChanged': 'Only sync metadata changed',
    'pages.loginpage.or': 'or',
    'pages.operations.operationsdashboardpage.14bc003d':
      '1) Identify data source; 2) Add the controller in the matching business API project; 3) Replace Empty placeholder with real chart. Long-term: Phase 3 data platform → Trino federated query.',
    'pages.operations.operationsdashboardpage.3f525994': 'Operations Dashboard',
    'pages.operations.operationsdashboardpage.52a57b7e': 'Placeholder Module',
    'pages.operations.operationsdashboardpage.660e1360': 'How to wire new data sources?',
    'pages.operations.operationsdashboardpage.70f31b9c': 'Data integration pending',
    'pages.operations.operationsdashboardpage.9c93433c':
      'Company-wide operations overview — Sales / R&D / Production / Supply Chain / Inventory / Delivery',
    'pages.operations.operationsdashboardpage.dd945db1':
      'Reserved module. Data wiring is staged per business priority — will integrate with SAP, MES, Jira, iws_deliverproject etc.',
    'pages.opportunity.opportunitycreatemodal.da0e789a': 'On Hold',
    'pages.opportunity.opportunitycreatemodal.e2fd47a2': 'In Progress',
    'pages.opportunity.opportunitydetailpage.0a944d46': 'Approve?',
    'pages.opportunity.opportunitydetailpage.18b480fd':
      "No quotes yet — click '+ New Quote' to create one",
    'pages.opportunity.opportunitydetailpage.19584257': 'POC Completed?',
    'pages.opportunity.opportunitydetailpage.1ab13cc2': 'Open',
    'pages.opportunity.opportunitydetailpage.29106709': 'Approve',
    'pages.opportunity.opportunitydetailpage.2aba701e': 'Confirm',
    'pages.opportunity.opportunitydetailpage.33ff9156': 'Approve Project?',
    'pages.opportunity.opportunitydetailpage.394f8bea': 'Sales Forecast',
    'pages.opportunity.opportunitydetailpage.4395f157': 'Unit Price',
    'pages.opportunity.opportunitydetailpage.481f341e': 'Approve',
    'pages.opportunity.opportunitydetailpage.482bc089': 'Confirm',
    'pages.opportunity.opportunitydetailpage.5342a4a7': 'Apply',
    'pages.opportunity.opportunitydetailpage.542f6578': 'Reject?',
    'pages.opportunity.opportunitydetailpage.569d2fb1': 'Cancel',
    'pages.opportunity.opportunitydetailpage.5f1d4c8e': 'Cannot go back to a previous stage',
    'pages.opportunity.opportunitydetailpage.5f2c228f': 'New Quote',
    'pages.opportunity.opportunitydetailpage.622a8037': 'Approve',
    'pages.opportunity.opportunitydetailpage.6b988583': 'Not Started',
    'pages.opportunity.opportunitydetailpage.70f40f78': 'POC',
    'pages.opportunity.opportunitydetailpage.7427768c': 'Won',
    'pages.opportunity.opportunitydetailpage.751f2a90': 'Total Amount',
    'pages.opportunity.opportunitydetailpage.79941986': 'Approve Project',
    'pages.opportunity.opportunitydetailpage.7f07399c': 'Project Creation',
    'pages.opportunity.opportunitydetailpage.80dd19c7': 'Completed',
    'pages.opportunity.opportunitydetailpage.81706428': 'Modified On',
    'pages.opportunity.opportunitydetailpage.826385b7': 'POC Application',
    'pages.opportunity.opportunitydetailpage.84251272': 'Quote Name',
    'pages.opportunity.opportunitydetailpage.88f5d6bf': 'Rejected',
    'pages.opportunity.opportunitydetailpage.8bd1fd2f': 'Reject',
    'pages.opportunity.opportunitydetailpage.8dad366f': 'Attachments',
    'pages.opportunity.opportunitydetailpage.8f9c36c6': 'Requirements Gathering',
    'pages.opportunity.opportunitydetailpage.919297bf': 'Approved',
    'pages.opportunity.opportunitydetailpage.92fa4f13': 'Reason (optional):',
    'pages.opportunity.opportunitydetailpage.93beaaf2': 'NDA',
    'pages.opportunity.opportunitydetailpage.ndaSkippable': 'NDA (Optional)',
    'pages.opportunity.opportunitydetailpage.ndaSkipHint':
      'NDA is optional for domestic opportunities. Advancing directly to Requirements Gathering.',
    'pages.opportunity.opportunitydetailpage.a3eed542': 'Products',
    'pages.opportunity.opportunitydetailpage.aab512c1': 'Lost',
    'pages.opportunity.opportunitydetailpage.b179d90c': 'No products on this opportunity',
    'pages.opportunity.opportunitydetailpage.b35228c1': 'Extended Amount',
    'pages.opportunity.opportunitydetailpage.b44aeb3b': 'Product',
    'pages.opportunity.opportunitydetailpage.c2202fdd': 'Opportunity Closed',
    'pages.opportunity.opportunitydetailpage.cb649758': 'Negotiation',
    'pages.opportunity.opportunitydetailpage.d1aac823': 'Project Approved',
    'pages.opportunity.opportunitydetailpage.d4a8687a': 'Quantity',
    'pages.opportunity.opportunitydetailpage.d7351f57': 'Number',
    'pages.opportunity.opportunitydetailpage.da35bcef': 'Sales Technical Support',
    'pages.opportunity.opportunitydetailpage.dc42c4c8': 'Quotes',
    'pages.opportunity.opportunitydetailpage.notesTab': 'Project Progress',
    'pages.opportunity.opportunitydetailpage.e2fcfd87': 'Mark as Lost',
    'pages.opportunity.opportunitydetailpage.e5f7d2db': 'Click a future stage circle to advance',
    'pages.opportunity.opportunitydetailpage.e7a201ed': 'Won',
    'pages.opportunity.opportunitydetailpage.ed5098cf': 'In progress',
    'pages.opportunity.opportunitydetailpage.eef87286': 'Mark as Won?',
    'pages.opportunity.opportunitydetailpage.ef889c19': 'Pending Approval',
    'pages.opportunity.opportunitydetailpage.efa6c136': 'POC Flow',
    'pages.opportunity.opportunitydetailpage.f5dfb8d4': 'Apply for POC?',
    'pages.opportunity.opportunitydetailpage.f774e7c2': 'Complete',
    'pages.opportunity.opportunitydetailpage.f9af59b5': 'Complete',
    'pages.opportunity.opportunitydetailpage.fd97f6c6': 'Submit',
    'pages.opportunity.opportunitydetailpage.ffdd6dc3': 'Lost',
    'pages.opportunity.opportunitynotestab.empty': 'No Project Progress records',
    'pages.opportunity.opportunitynotestab.create': 'New',
    'pages.opportunity.opportunitynotestab.pinned': 'Pinned',
    'pages.opportunity.opportunitynotestab.refresh': 'Refresh',
    'pages.opportunity.opportunitynotestab.title': 'Project Progress',
    'pages.opportunity.opportunitynotestab.unknownAuthor': 'Unknown user',
    'pages.opportunity.stageadvancemodal.0557016e': 'Current Stage Fields',
    'pages.opportunity.stageadvancemodal.13f344eb': 'OA Status',
    'pages.opportunity.stageadvancemodal.1965514e': 'POC',
    'pages.opportunity.stageadvancemodal.215273a5': 'Opportunity Closed',
    'pages.opportunity.stageadvancemodal.2fffb90b': 'Next Stage Expected End Date：',
    'pages.opportunity.stageadvancemodal.32e44d92': 'Current',
    'pages.opportunity.stageadvancemodal.461ef383': 'Target',
    'pages.opportunity.stageadvancemodal.5586cee4': 'Advance BPF Stage',
    'pages.opportunity.stageadvancemodal.56ded777': 'Negotiation',
    'pages.opportunity.stageadvancemodal.6956d5aa': 'Advance',
    'pages.opportunity.stageadvancemodal.6d724f1b': 'Project Approved',
    'pages.opportunity.stageadvancemodal.797bab60': 'Start POC',
    'pages.opportunity.stageadvancemodal.957a8cdd': 'Requirements Gathering',
    'pages.opportunity.stageadvancemodal.9b6d9ef5': 'Amount',
    'pages.opportunity.stageadvancemodal.9cec40a1': 'POC Deadline',
    'pages.opportunity.stageadvancemodal.af35f9d1': 'Not Started',
    'pages.opportunity.stageadvancemodal.b722aed6': 'NDA',
    'pages.opportunity.stageadvancemodal.c1c32b4b': 'POC Application',
    'pages.opportunity.stageadvancemodal.d7c138b8': 'Project Creation',
    'pages.opportunity.stageadvancemodal.dac80f16': 'Next Stage Plan',
    'pages.opportunity.stageadvancemodal.e7881be1': 'Next stage expected end date is required',
    'pages.opportunity.stageadvancemodal.eb49cc39': 'Summary',
    'pages.opportunity.stageadvancemodal.f85285ff': 'Cancel',
    'pages.pricing.pricingpages.e37b9537': 'Part#',
    'pages.quote.quotecreatemodal.4cbbe265': 'Domestic',
    'pages.quote.quotecreatemodal.70f8bf64': 'Overseas',
    'pages.quote.quotedetailpage.0572baa1': 'Quote Lines',
    'pages.quote.quotedetailpage.13cd594c': 'Send to SAP Sales Doc (ZSDIF017)',
    'pages.quote.quotedetailpage.13e5f371': 'Auto Check',
    'pages.quote.quotedetailpage.1435b68a': 'Confirm',
    'pages.quote.quotedetailpage.17c283f8': 'Auto-Advance',
    'pages.quote.quotedetailpage.23e88389': 'Manager Approve',
    'pages.quote.quotedetailpage.2d2a1f7f': 'Director Approve',
    'pages.quote.quotedetailpage.2fdbc3f7': 'Activate',
    'pages.quote.quotedetailpage.37e727a3': 'Freight Review',
    'pages.quote.quotedetailpage.3912b99c': 'Draft',
    'pages.quote.quotedetailpage.605cf536': 'System',
    'pages.quote.quotedetailpage.60f3fd34': 'VAT display rules).',
    'pages.quote.quotedetailpage.64f21964': 'Replace (delete existing rows)',
    'pages.quote.quotedetailpage.6c5bc8b9': 'Cancel',
    'pages.quote.quotedetailpage.7240ff1c': 'Next Stage',
    'pages.quote.quotedetailpage.77e467c3': 'Won',
    'pages.quote.quotedetailpage.7dfc87d1': 'Sync from BOQ',
    'pages.quote.quotedetailpage.87cc37fe': 'Select PDF Template',
    'pages.quote.quotedetailpage.892323f1': 'Compliance Check',
    'pages.quote.quotedetailpage.8b9a4cca': 'Accepted',
    'pages.quote.quotedetailpage.8d05a975': 'Append (keep existing rows)',
    'pages.quote.quotedetailpage.8e9db337': 'Closed',
    'pages.quote.quotedetailpage.905befbd': 'Send to SAP',
    'pages.quote.quotedetailpage.98d86244': 'Process',
    'pages.quote.quotedetailpage.9aa0610f': 'Quote Information',
    'pages.quote.quotedetailpage.a0c0cc2e': 'Auto-skip Freight / Director Approve',
    'pages.quote.quotedetailpage.a349ea0b': 'Sent',
    'pages.quote.quotedetailpage.a77b2dbb': 'Download',
    'pages.quote.quotedetailpage.aad48535': 'Active',
    'pages.quote.quotedetailpage.b0f81672': 'Advance Quote Stage',
    'pages.quote.quotedetailpage.b3306398': 'Downloaded',
    'pages.quote.quotedetailpage.c4446511': 'Summary',
    'pages.quote.quotedetailpage.c69e445f':
      'Enqueued async — VBELN written back after SAP processes. Re-click safely updates.',
    'pages.quote.quotedetailpage.c793035b': 'Sync',
    'pages.quote.quotedetailpage.cb644515': 'Pricing Review',
    'pages.quote.quotedetailpage.ccb96a97': 'Not Started',
    'pages.quote.quotedetailpage.d424b5f2': 'Price Lookup',
    'pages.quote.quotedetailpage.d4f1d6f3': 'Target Stage:',
    'pages.quote.quotedetailpage.dd117807': 'Amounts',
    'pages.quote.quotedetailpage.eb01af51': 'Current Stage',
    'pages.quote.quotedetailpage.eea2eb42': 'Advance',
    'pages.quote.quotedetailpage.f57ea53a': 'Price Review',
    'pages.quote.quotedetailpage.ff0abbae': 'Download PDF',
    'pages.sinosure.sinosurecreatemodal.8253bf63': 'T 30 days',
    'pages.sinosure.sinosuredetailpage.06d1f7a0': 'Sinosure Process',
    'pages.sinosure.sinosuredetailpage.0781693b': 'Review',
    'pages.sinosure.sinosuredetailpage.0ca3650a': 'Advance Sinosure Stage',
    'pages.sinosure.sinosuredetailpage.0e42dbbd': 'Next Stage',
    'pages.sinosure.sinosuredetailpage.200ba928': 'Target Stage:',
    'pages.sinosure.sinosuredetailpage.21ec1d84': 'Not Started',
    'pages.sinosure.sinosuredetailpage.25a41019': 'Current Stage',
    'pages.sinosure.sinosuredetailpage.294a16ad': 'Sinosure Approve',
    'pages.sinosure.sinosuredetailpage.62af2156': 'Approval',
    'pages.sinosure.sinosuredetailpage.6ac07778': 'Cancel',
    'pages.sinosure.sinosuredetailpage.8d8d1f8e': 'System',
    'pages.sinosure.sinosuredetailpage.93874381': 'Advance',
    'pages.sinosure.sinosuredetailpage.951bfef3': 'Application',
    'pages.sinosure.sinosuredetailpage.9c23dde8': 'Sinosure Information',
    'pages.sinosure.sinosuredetailpage.b6a0f402': 'Sinosure Documents',
    'pages.sinosure.sinosuredetailpage.b84c2dc5': 'Completed',
    'pages.sinosure.sinosuredetailpage.c00bfadf': 'Summary',
    'pages.sinosure.sinosuredetailpage.f21579d4': 'Attachments',
    'pages.worklist.worklistpage.42e7c8a0': 'Work List',
    'pages.worklist.worklistpage.d635b169': 'No open items',
  },
} as const;
